import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const ResidenceDefaultSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5024 2.16658C12.5426 1.4706 11.2444 1.47006 10.284 2.16523L2.13443 8.06468C1.4219 8.58047 1 9.40672 1 10.2864V21.113H9.2811V12.9663H14.658V21.113H22.9415V10.4106C22.9415 9.53175 22.5204 8.70615 21.8089 8.19024L13.5024 2.16658Z"
      fill="#D7E0EE"
    />
    <path
      d="M18.8275 3.67517V8.24631"
      stroke="#D7E0EE"
      strokeWidth="1.37134"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgWrapper>
)
